<!-- eslint-disable -->
<template>
  <div class="card bg-white border-0 rounded-3 mb-4 shadow-sm">
    <div class="card-body p-0">

      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 p-4">

        <div class="d-flex align-items-center gap-3">
          <!--          <input type="number" class="form-control w-auto" v-model="listQuery.year" placeholder="Выберите год"
                           @change="handleFilter">-->
          <select
              v-model="listQuery.year"
              class="form-select form-control- form-select-sm w-auto "
              @change="handleFilter"
              aria-label="Выберите год"
          >
            <option value="" disabled selected>Выберите год</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>


          <select class="form-select w-auto" v-model="listQuery.month" @change="handleFilter">
            <option v-for="(month, index) in months" :key="index" :value="index + 1">{{ month.label }}</option>
          </select>

          <select class="form-select w-auto" v-model="listQuery.recruiterType" @change="handleFilter">
            <option value="">Все</option>
            <option v-for="(type, index) in recruiterTypes" :key="index" :value="index + 1">{{ type.label }}</option>
          </select>

          <button v-if="userRole === 'grand_admin' || userRole === 'admin' || userRole === 'manager'"
                  class="btn btn-primary" :disabled="downloadLoading" @click="handleDownload">
            экспорт Excel
          </button>
        </div>
      </div>

      <div class="default-table-area style-two all-projects">
        <div class="table-responsive">
          <table class="table table-bordered table-striped- table-hover align-middle">
            <thead class="table-light">
            <tr>
              <th>#</th>
              <th v-for="field in fields" :key="field.name">{{ field.label }}</th>
<!--              <th v-if="userRole === 'grand_admin' || userRole === 'admin'">Действия</th>-->
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in listRecruiters" :key="row.id">
              <td>{{ index + 1 }}</td>
              <td v-for="field in fields" :key="field.name">
                <span v-if="field.name === 'name'">{{ row.name }}</span>
                <span v-if="field.name === 'recruiter_hours'">{{ parseFloat(row.total_working_hours) }}</span>
                <div v-if="field.name === 'bonus'">
                  <div
                      v-if="row.bonuses && row.bonuses[listQuery.month + '-' + new Date(listQuery.year).getFullYear()]">
                    {{ parseFloat(row.bonuses[listQuery.month + '-' + new Date(listQuery.year).getFullYear()].bonus) }}
                  </div>
                  <div v-else>{{ parseFloat(row.bonus) }}</div>
                </div>
                <span v-if="field.name === 'candidates_hours'">{{ parseFloat(row.user_hours_hired) }}</span>
                <div v-if="field.name === 'salary'">
                  <div
                      v-if="row.bonuses && row.bonuses[listQuery.month + '-' + new Date(listQuery.year).getFullYear()]">
                    {{ parseFloat(row.bonuses[listQuery.month + '-' + new Date(listQuery.year).getFullYear()].salary) }}
                  </div>
                  <div v-else>{{ parseFloat(row.salary) }}</div>
                </div>
              </td>
<!--              <td v-if="userRole === 'grand_admin' || userRole === 'admin'">
                <button class="btn btn-sm btn-primary"
                        @click="openHoursModal(row.id, row, row.bonuses && row.bonuses[listQuery.month + '-' + new Date(listQuery.year).getFullYear()] ? row.bonuses[listQuery.month + '-' + new Date(listQuery.year).getFullYear()].bonus : 0)">
                  Редактировать
                </button>
              </td>-->
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" v-if="dialogPvVisible" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Редактировать премию/бонус</h5>
          <button type="button" class="btn-close" @click="dialogPvVisible = false"></button>
        </div>
        <div class="modal-body">
          <form ref="dataForm">
            <div class="mb-3">
              <label class="form-label">{{ userBonusData.name }}</label>
              <input type="text" class="form-control" v-model="userBonusData.bonus" placeholder="Премия">
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="storeBonuses(); dialogPvVisible = false">Сохранить
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {fetchList, fetchPv, createCandidate, updateCandidate, deleteCandidate} from '@/api/candidate';
import {fetchListRecruiters} from '@/api/stats';
import {fetchPosition} from '@/api/position';

import {parseTime} from '@/utils';
import {saveBonuses} from '@/api/actualization';


const calendarTypeOptions = [
  {key: 'US', display_name: 'USA'},
];

const calendarTypeKeyValue = calendarTypeOptions.reduce((acc, cur) => {
  acc[cur.key] = cur.display_name;
  return acc;
}, {});

export default {
  name: 'statsTable',
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'info',
        deleted: 'danger',
      };
      return statusMap[status];
    },
    typeFilter(type) {
      return calendarTypeKeyValue[type];
    },
  },
  data() {
    return {
      tempBonus: {},
      fromVacancy: false,
      peselOption: 'no',
      peselOption2: 'no',
      userRole: '',
      position: null,
      checkedFields: ['name', 'phone', 'passport', 'pesel'],
      tableKey: 0,
      vacancies: [],
      recruiters: [],
      list: null,
      listRecruiters: null,
      total: 0,
      listLoading: true,
      listQuery: {
        isSortedByPeople: 0,
        isSortedByHours: 0,
        isSortedByHoursCurrentMonth: 0,
        isSortedByVacancies: 0,
        isBlackList: 0,
        search: '',
        sort: '+id',
        status: null,
        //year: new Date(),
        year: 2025,
        month: new Date().getMonth(),
        recruiterType: null
      },
      years: [
        2024,
        2025,
      ],
      months: [
        {label: 'Январь'},
        {label: 'Февраль'},
        {label: 'Март'},
        {label: 'Апрель'},
        {label: 'Май'},
        {label: 'Июнь'},
        {label: 'Июль'},
        {label: 'Август'},
        {label: 'Сентябрь'},
        {label: 'Октябрь'},
        {label: 'Ноябрь'},
        {label: 'Декабрь'},
      ],
      recruiterTypes: [
        {label: 'UZ'},
        {label: 'USU'},
      ],
      calendarTypeOptions,
      sortOptions: [{label: 'ID Ascending', key: '+id'}, {label: 'ID Descending', key: '-id'}],
      statusOptions: ['published', 'draft', 'deleted'],
      showReviewer: false,
      formattedVacancies: [],
      temp: {
        name: '',
        vacancyCandidateId: null,
        is_pair: 0,
        pesel: '',
        recruiterId: ''
      },
      temp2: {
        name: '',
        vacancyCandidateId: null,
        gender: 3,
        is_pair: 1,
        pesel: '',
        recruiterId: ''
      },
      dialogFormVisible: false,
      dialogFieldsVisible: false,
      dialogBlackListVisible: false,
      dialogStatus: '',
      textMap: {
        update: 'Edit',
        create: 'Create',
      },
      dialogPvVisible: false,
      userBonusData: [],
      pvData: [],
      fields: [
        {label: 'Имя фамилия рекрутера', name: 'name', showAsMain: true},
        {label: 'Часы работы', name: 'recruiter_hours', showAsMain: true},
        {label: 'Часы кандидатов', name: 'candidates_hours', showAsMain: true},
        {label: 'Премия/бонус', name: 'bonus', showAsMain: true},
        {label: 'Зарплата', name: 'salary', showAsMain: true},
      ],
      rules: this.setRules(),
      downloadLoading: false,
    };
  },
  created: async function () {
    this.loadSearchTerm(); // Load initial search term
    this.startStoragePolling(); // Start polling local storage
    this.getList(this.listQuery);
    this.getListRecruiters(this.listQuery);
  },
  methods: {
    loadSearchTerm() {
      this.listQuery.search = localStorage.getItem("searchTerm") || ""; // Load from local storage
      console.log(this.listQuery.search);
    },
    handleStorageChange(event) {
      if (event.key === "searchTerm") {
        this.searchTerm = event.newValue; // Update search term when local storage changes
        this.getListRecruiters(this.listQuery);
      }
    },
    startStoragePolling() {
      // Poll local storage for changes every 500ms
      this.storagePollingInterval = setInterval(() => {
        const currentSearchTerm = localStorage.getItem("searchTerm") || "";
        if (currentSearchTerm !== this.listQuery.search) {
          this.listQuery.search = currentSearchTerm; // Update search term
          this.getListRecruiters(); // Perform search
        }
      }, 500);
    },
    stopStoragePolling() {
      // Clear the polling interval
      if (this.storagePollingInterval) {
        clearInterval(this.storagePollingInterval);
      }
    },
    storeBonuses() {
      saveBonuses(this.userBonusData).then(() => {
        this.$notify({
          title: 'Успешно',
          message: 'Успешно',
          type: 'success',
          duration: 2000,
        });
        window.location.reload();
      });
    },
    openHoursModal(user_id, userBonusData, additionalBonus = 0) {
      this.userBonusData = userBonusData;
      this.userBonusData.month = this.listQuery.month;
      this.userBonusData.year = this.listQuery.year;
      if (additionalBonus > 0) {
        this.userBonusData.initialBonus = additionalBonus;
        this.userBonusData.bonus = additionalBonus;
      } else {
        this.userBonusData.initialBonus = this.userBonusData.bonus;
      }
      this.dialogPvVisible = true;
    },
    formatDate2(date) {
      if (!date) return '';
      const options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return new Date(date).toLocaleDateString('ru-RU', options); // Format to 'YYYY-MM-DD'
    },
    formatDate(date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
    parseStatusFromUrl() {
      const path = this.$route.path;
      const regex = /status(\d+)/;
      const match = path.match(regex);
      if (match && match[1]) {
        this.listQuery.status = match[1];
      } else {
        this.listQuery.status = this.$route.query.status || null;
      }
      if (this.$route.query['main-search']) {
        this.listQuery.search = this.$route.query['main-search'];
      }
      if (this.listQuery.status) {
        this.getList()
      }
    },
    checkBlackList() {
      const fullUrl = window.location.href;
      this.listQuery.isBlackList = fullUrl.includes('black-list') ? 1 : 0;
    },
    // isArrivalDateRequired() {
    //   return this.temp.status === 'Приезд';
    // },
    setRules() {
      return {
        name: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        phone: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        passport: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        /*  pesel: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],*/
        comment: [{required: false, message: 'Обязательное поле', trigger: 'blur'}],
        gender: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
      };
    },
    async getList() {
      this.listLoading = true;
      const data = await fetchList(this.listQuery);
      if (data.redirect_to) {
        window.location.href = data.redirect_to;
      }
      this.list = data.candidates.items;
      this.total = data.candidates.total;
      this.vacancies = data.vacancies;
      this.userRole = data.userRole;
      this.formatVacancies(this.vacancies);
      this.recruiters = data.recruiters;
      if (this.recruiters.length === 1) {
        this.temp.recruiterId = this.recruiters[0].id;
        this.temp2.recruiterId = this.recruiters[0].id;
      }
      this.listLoading = false;
    },
    async getListRecruiters() {
      this.listLoading = true;
      const data = await fetchListRecruiters(this.listQuery);
      this.listRecruiters = data.recruiters;
      console.log(data);
      this.listLoading = false;
    },
    formatVacancies(data) {
      let options = [];
      this.vacancies.forEach(vacancy => {
        vacancy.vacancy_candidates.forEach(candidate => {
          options.push({
            label: `${vacancy.title}/${candidate.position}`,
            value: candidate.id
          });
        });
      });
      this.formattedVacancies = options;
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getListRecruiters();
    },
    resetTemp() {
      this.temp = {};
    },
    handleCreate(fromVacancy = false) {
      if (!fromVacancy) {
        this.resetTemp();
      }
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    handleBlackList() {
      this.dialogBlackListVisible = true;
    },
    createData() {
      if (this.temp.status === 'Приезд' && !this.temp.arrivalDate) {
        alert('Введите дату приезда');
        return
      }
      if (this.peselOption === 'yes' && this.temp.pesel === '') {
        alert('Введите pesel');
        return
      }
      if (this.peselOption2 === 'yes' && this.temp.pesel2 === '') {
        alert('Введите pesel для пары');
        return
      }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          createCandidate(this.temp).then(() => {
            if (this.temp.gender === 3 && this.temp2.name !== '') {
              createCandidate(this.temp2).then(() => {
                console.log('pair created');
              });
            }
            this.list.unshift(this.temp);
            this.dialogFormVisible = false;
            this.$notify({
              title: 'Успешно',
              message: 'Успешно',
              type: 'success',
              duration: 2000,
            });
            if (this.fromVacancy) {
              window.location.href = '/#/candidates/status1';
            } else {
              window.location.reload();
            }
          });
        }
      });
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row); // copy obj
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp);
          updateCandidate(tempData).then(() => {
            for (const v of this.list) {
              if (v.id === this.temp.id) {
                const index = this.list.indexOf(v);
                this.list.splice(index, 1, this.temp);
                break;
              }
            }
            this.dialogFormVisible = false;
            this.$notify({
              title: 'Успешно',
              message: 'Данные успешно изменены',
              type: 'success',
              duration: 2000,
            });
            let redirect = '1';
            if (this.temp.status === 'Работает') {
              redirect = '3';
            } else if (this.temp.status === 'Не работает') {
              redirect = '4';
            }
            window.location.href = '/#/candidates/status' + redirect;
          });
        }
      });
    },
    handleDelete(row) {
      if (confirm('подтвердить удаление')) {
        deleteCandidate(row).then(() => {
          this.$notify({
            title: 'Успешно',
            message: 'Удалено',
            type: 'success',
            duration: 2000,
          });
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });
      }
    },
    handleFetchPv(pv) {
      fetchPv(pv).then(response => {
        this.pvData = response.data.pvData;
        this.dialogPvVisible = true;
      });
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = e => {
        this.temp.image = e.target.result;
      };
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j]);
        } else {
          return v[j];
        }
      }));
    },
    handleDownload() {
      /*      this.downloadLoading = true;
            import('@/vendor/Export2Excel').then((excel) => {
              const tHeader = [
                'Имя фамилия рекрутера',
                'Количество часов',
                'Количество часов кандидатов',
                'Премия/бонус',
                'Зарплата',
                'Кандидат',
                'Работа от',
                'Работа до',
                'Часы',
                'Проект',
                'Координатор'
              ];

              const list = this.listRecruiters;

              // Function to safely access nested properties
              const safeAccess = (obj, path, defaultValue = '') =>
                  path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : defaultValue), obj);

              // Combine main and expanded content into consistent rows
              const data = list.flatMap((recruiter) => {
                // Extract main row data, ensuring all values are present
                const mainRow = [
                  safeAccess(recruiter, 'name'),
                  safeAccess(recruiter, 'total_working_hours'),
                  safeAccess(recruiter, 'user_hours_hired'),
                  safeAccess(recruiter, 'bonus'),
                  safeAccess(recruiter, 'salary')
                ];

                // Handle expanded rows
                const expandedRows = (recruiter.actualizations || []).map((item) => [
                  safeAccess(item, 'candidate.name'),
                  safeAccess(item, 'candidate.arrival_date', 'N/A'),
                  safeAccess(item, 'end_date', 'N/A'),
                  safeAccess(item, 'hours', 0),
                  safeAccess(item, 'candidate.position.vacancy.title', 'N/A'),
                  safeAccess(item, 'candidate.position.vacancy.coordinator.name', 'N/A')
                ]);

                // Pad and combine rows for Excel
                const mainRowPadded = [...mainRow, ...Array(tHeader.length - mainRow.length).fill('')];
                const formattedExpandedRows = expandedRows.map((row) =>
                    [...Array(5).fill(''), ...row] // Indent expanded rows
                );

                return [mainRowPadded, ...formattedExpandedRows];
              });

              // Ensure no undefined or null values in data
              const cleanedData = data.map((row) =>
                  row.map((cell) => (cell === undefined || cell === null ? '' : cell))
              );

              // Export to Excel
              excel.export_json_to_excel({
                header: tHeader,
                data: cleanedData,
                filename: 'candidates_with_details',
                autoWidth: this.autoWidth,
                bookType: this.bookType
              });

              this.downloadLoading = false;
            });*/
    },
    getSortMethod(fieldName) {
      return (a, b) => {
        let valA, valB;

        switch (fieldName) {
          case 'recruiter_hours':
            valA = parseFloat(a.total_working_hours);
            valB = parseFloat(b.total_working_hours);
            break;
          case 'bonus':
            valA = a.bonuses && a.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()]
                ? parseFloat(a.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()].bonus)
                : parseFloat(a.bonus);
            valB = b.bonuses && b.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()]
                ? parseFloat(b.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()].bonus)
                : parseFloat(b.bonus);
            break;
          case 'candidates_hours':
            valA = parseFloat(a.user_hours_hired);
            valB = parseFloat(b.user_hours_hired);
            break;
          case 'salary':
            valA = a.bonuses && a.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()]
                ? parseFloat(a.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()].salary)
                : parseFloat(a.salary);
            valB = b.bonuses && b.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()]
                ? parseFloat(b.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()].salary)
                : parseFloat(b.salary);
            break;
          default:
            return 0; // Handle other fields or default case
        }

        return valA - valB;
      };
    }
  },
};
</script>
<style scoped>


</style>
<!-- eslint-enable -->
